import {dataLimitMode} from './GraphUiState'

//Liste des mode 
export class GraphSimulationState {

    public typeUiid:string
    public refresh:boolean
    public fields:Array<string>    
    public pointSize:number
    public dataLimit:string
    public zoom:string
    

    constructor({                
                typeUiid="detail", //detail ou global
                refresh=false,   
                pointSize=2,
                zoom="ZoomXAxis",
                dataLimit=dataLimitMode.ALL,             
                fields=[]
            } = {}) {  
        this.typeUiid = typeUiid
        this.refresh = refresh        
        this.fields = fields
        this.pointSize = pointSize
        this.dataLimit = dataLimit
        this.zoom = zoom     
    }
}